import { Host, h, } from "@stencil/core";
import state from "../store";
export class GxgDropDown {
    constructor() {
        this.width = "240px";
        this.minWidth = "0";
        this.maxWidth = "none";
        this.dropDownHeight = "auto";
        this.label = undefined;
        this.icon = "";
        this.showContent = false;
        this.position = "bottom";
        this.initialButtonText = "";
        this.detectClickOutsideDropDown = this.detectClickOutsideDropDownFunc.bind(this);
        this.detectMouseScroll = this.detectMouseScrollFunc.bind(this);
        this.myObserver = null;
    }
    el;
    mainContainer;
    contentContainer;
    /**
     * This events gets fired when the dropdown is opened
     */
    opened;
    /**
     * This events gets fired when the dropdown is closed
     */
    closed;
    componentDidUpdate() {
        const contentContainerIsOverflowing = this.contentContainerOverflows();
        if (contentContainerIsOverflowing) {
            this.el.classList.add("position-top");
            this.el.classList.remove("position-bottom");
        }
        else {
            this.el.classList.add("position-bottom");
            this.el.classList.remove("position-top");
        }
    }
    componentWillLoad() {
        const slotButton = this.el.querySelector("[slot=button]");
        if (slotButton === null) {
            this.initialButtonText = "Select item";
        }
    }
    componentDidLoad() {
        this.resizeObserver();
    }
    toggleContent() {
        if (this.showContent === true) {
            this.showContent = false;
        }
        else {
            this.showContent = true;
        }
    }
    detectClickOutsideDropDownFunc(event) {
        const dropDownContentContainer = this.el.shadowRoot.querySelector(".select-container");
        const contentContainer = this.el.shadowRoot.querySelector(".content-container");
        const x = event.x;
        const y = event.y;
        //Contextual menu coordinates
        const dropDownContentContainerArea = dropDownContentContainer.getBoundingClientRect();
        const contentContainerArea = contentContainer.getBoundingClientRect();
        if ((x > dropDownContentContainerArea.left &&
            x < dropDownContentContainerArea.right &&
            y > dropDownContentContainerArea.top &&
            y < dropDownContentContainerArea.bottom) ||
            (x > contentContainerArea.left &&
                x < contentContainerArea.right &&
                y > contentContainerArea.top &&
                y < contentContainerArea.bottom)) {
            //Click happened inside the dropdown
        }
        else {
            this.showContent = false;
            //Click happened outside the dropdown
        }
    }
    detectMouseScrollFunc(e) {
        if (e.target === document) {
            this.showContent = false;
        }
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.detectClickOutsideDropDown, true);
        document.removeEventListener("scroll", this.detectMouseScroll, true);
        this.myObserver.unobserve(document.body);
    }
    watchHandler(newValue) {
        if (newValue === true) {
            this.opened.emit(true);
            document.addEventListener("click", this.detectClickOutsideDropDown, true);
            document.addEventListener("scroll", this.detectMouseScroll, true);
            //Reposition .content-container, since it has fixed position
            this.repositionContentContainer();
        }
        else {
            this.closed.emit(true);
            document.removeEventListener("click", this.detectClickOutsideDropDown, true);
            document.removeEventListener("scroll", this.detectMouseScroll, true);
        }
    }
    onKeyDown(e) {
        if (e.key === "ArrowDown") {
            this.showContent = true;
        }
        else if (e.key === "Enter") {
            this.toggleContent();
        }
        else if (e.key === "Escape") {
            this.showContent = false;
        }
        else if (e.key === "Tab") {
            this.showContent = false;
        }
    }
    onKeyDownGxgButtonArrowDown(e) {
        if (e.key === "Enter") {
            this.toggleContent();
        }
    }
    resizeObserver() {
        this.myObserver = new ResizeObserver((entries) => {
            entries.forEach(() => {
                this.repositionContentContainer();
            });
        });
        this.myObserver.observe(document.body);
        this.myObserver.observe(this.el);
    }
    repositionContentContainer() {
        //redefine .main-container width
        const gxgDropDownWidth = this.el.clientWidth;
        this.contentContainer.style.width = gxgDropDownWidth + "px";
        //redefine .content-container "top" value
        const gxgDropDownCoordinates = this.el.getBoundingClientRect();
        const gxgDropDownY = gxgDropDownCoordinates.y;
        const gxgDropDownHeight = gxgDropDownCoordinates.height;
        this.contentContainer.style.top = gxgDropDownY + gxgDropDownHeight + "px";
    }
    contentContainerOverflows() {
        const viewportHeight = window.innerHeight;
        const dropdownBottom = this.el.getBoundingClientRect().bottom;
        const contentContainerHeight = this.contentContainer.clientHeight;
        const result = dropdownBottom + contentContainerHeight;
        const itOverflows = true ? result > viewportHeight : false;
        return itOverflows;
    }
    render() {
        return (h(Host, { class: {
                large: state.large,
            }, style: {
                width: this.width,
                minWidth: this.minWidth,
                maxWidth: this.maxWidth,
            }, onClick: this.toggleContent.bind(this), onKeyDown: this.onKeyDown.bind(this) }, h("div", { class: { "main-container": true }, ref: (el) => (this.mainContainer = el) }, this.label ? (h("gxg-label", { class: { label: true } }, this.label)) : null, h("div", { tabIndex: 0, class: {
                "select-container": true,
                "nothing-selected": this.initialButtonText === "Select item",
            } }, this.icon !== "" ? (h("gxg-icon", { class: "icon", type: this.icon, color: "auto", size: "small" })) : null, this.initialButtonText !== "" ? this.initialButtonText : null, h("slot", { name: "button" }), h("gxg-button", { class: { "arrow-down-button": true }, icon: "navigation/arrow-down", type: "tertiary", onKeyDown: this.onKeyDownGxgButtonArrowDown.bind(this), tabindex: "-1" })), h("div", { class: {
                "content-container": true,
                "content-container--show": this.showContent,
            }, style: {
                height: this.dropDownHeight,
            }, ref: (el) => (this.contentContainer = el) }, h("slot", null)))));
    }
    static get is() { return "gxg-drop-down"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["drop-down.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["drop-down.css"]
        };
    }
    static get properties() {
        return {
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The dropdown width"
                },
                "attribute": "width",
                "reflect": false,
                "defaultValue": "\"240px\""
            },
            "minWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The dropdown min-width"
                },
                "attribute": "min-width",
                "reflect": false,
                "defaultValue": "\"0\""
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The codropdownmbo max-width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"none\""
            },
            "dropDownHeight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the dropdown height"
                },
                "attribute": "drop-down-height",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | undefined",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the dropdown label (optional)"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the dropdown icon (optional)"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "showContent": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Displays the dropdown content"
                },
                "attribute": "show-content",
                "reflect": false,
                "defaultValue": "false"
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"top\" | \"bottom\"",
                    "resolved": "\"bottom\" | \"top\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The container 'items container' position"
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"bottom\""
            }
        };
    }
    static get states() {
        return {
            "initialButtonText": {},
            "detectClickOutsideDropDown": {},
            "detectMouseScroll": {},
            "myObserver": {}
        };
    }
    static get events() {
        return [{
                "method": "opened",
                "name": "opened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This events gets fired when the dropdown is opened"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "closed",
                "name": "closed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This events gets fired when the dropdown is closed"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "showContent",
                "methodName": "watchHandler"
            }];
    }
}
//# sourceMappingURL=drop-down.js.map
